// ===============================
// pages/Shop.jsx
// ===============================

import React, {
  useEffect,
  useState,
  useContext,
} from "react";
import {
  useSearchParams,
} from "react-router-dom";
import { Link } from "react-router-dom";

import axios from "axios";

import {
  CartContext,
} from "../../context/CartContext";

import "./Shop.css";

const Shop = () => {

  // ===============================
  // CONTEXT
  // ===============================

  const {
    addToCart,
  } = useContext(CartContext);
const [searchParams] =
  useSearchParams();
  // ===============================
  // STATES
  // ===============================

  const [products, setProducts] =
    useState([]);

  const [loading, setLoading] =
    useState(true);

  const [search, setSearch] =
    useState("");

 const [category, setCategory] =
  useState(

    searchParams.get("category") ||
    "All"

  );

  // ===============================
  // FETCH PRODUCTS
  // ===============================

  useEffect(() => {

    fetchProducts();

  }, []);

  const fetchProducts = async () => {

    try {

      const res = await axios.get(
        "http://localhost:5000/api/products"
      );

      setProducts(res.data);

      setLoading(false);

    } catch (error) {

      console.log(error);

      setLoading(false);

    }

  };

  // ===============================
  // FILTER PRODUCTS
  // ===============================

  const filteredProducts =
    products.filter((item) => {

      const matchesSearch =
        item.name
          ?.toLowerCase()
          .includes(search.toLowerCase());

      const matchesCategory =
        category === "All" ||
        item.category === category;

      return (
        matchesSearch &&
        matchesCategory
      );

    });

  // ===============================
  // UNIQUE CATEGORIES
  // ===============================

  const categories = [
    "All",
    ...new Set(
      products.map(
        (item) => item.category
      )
    ),
  ];

  return (
    <div className="shop-page">

      {/* HEADER */}

      <div className="shop-header">

        <div className="container">

          <h1>Shop Products</h1>

          <p>
            Discover premium quality products
          </p>

        </div>

      </div>

      {/* FILTERS */}

      <div className="shop-filters">

        <div className="container filter-wrapper">

          <input
            type="text"
            placeholder="Search products..."
            value={search}
            onChange={(e) =>
              setSearch(e.target.value)
            }
          />

          <select
            value={category}
            onChange={(e) =>
              setCategory(e.target.value)
            }
          >

            {categories.map((cat, index) => (

              <option
                key={index}
                value={cat}
              >
                {cat}
              </option>

            ))}

          </select>

        </div>

      </div>

      {/* PRODUCTS */}

      <div className="shop-products">

        <div className="container">

          {loading ? (

            <div className="loading-box">

              <h2>
                Loading Products...
              </h2>

            </div>

          ) : filteredProducts.length ===
            0 ? (

            <div className="loading-box">

              <h2>
                No Products Found
              </h2>

            </div>

          ) : (

            <div className="products-grid">

              {filteredProducts.map(
                (product) => (

                  <div
                    className="product-card"
                    key={product._id}
                  >

                    {/* CLICKABLE AREA */}

                    <Link
                      to={`/product/${product._id}`}
                      className="product-link"
                    >

                      {/* IMAGE */}

                      <div className="product-image">

                        <img
                          src={product.image}
                          alt={product.name}
                        />

                        <span className="product-category">
                          {
                            product.category
                          }
                        </span>

                      </div>

                      {/* INFO */}

                      <div className="product-info">

                        <h3>
                          {product.name}
                        </h3>

                        <p className="price">
                          ₹{product.price}
                        </p>

                        <p className="description">
                          {
                            product.description
                          }
                        </p>

                      </div>

                    </Link>

                    {/* BUTTON */}

                    <div className="product-btn-area">

                      <button
                        onClick={() =>
                          addToCart(product)
                        }
                      >
                        Add To Cart
                      </button>

                    </div>

                  </div>

                )
              )}

            </div>

          )}

        </div>

      </div>

    </div>
  );
};

export default Shop;